export default __webpack_public_path__ + "static/media/gpay.461b5ae0.webp";